import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { CONFIG } from '../constants/constants';
import { catchError, map, tap } from 'rxjs/operators';
import { HandlerExceptions } from '../utils/handlerexception';
import { Usuario } from '../model/usuario';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root',
})
export class SesionService {
    private _usuario: Usuario;
    private _token: string;
    private _menu: any;
    private usuarioLogueado = new Subject<boolean>();

    constructor(
        private http: HttpClient,
        private router: Router
    ) {
        this.usuarioLogueado.next(false);
    }

    /**
     * Obtener el usuario de la sesión
     */
    public get usuario(): Usuario {
        if (this._usuario != null) {
            return this._usuario;
        } else if (
            this._usuario == null &&
            sessionStorage.getItem('usuario') != null
        ) {
            this._usuario = JSON.parse(
                sessionStorage.getItem('usuario')
            ) as Usuario;
            return this._usuario;
        }
        return new Usuario();
    }

    /**
     * Obtener el token generado por el usuario
     */
    public get token(): string {
        if (this._token != null) {
            return this._token;
        } else if (
            this._token == null &&
            sessionStorage.getItem('token') != null
        ) {
            this._token = sessionStorage.getItem('token');
            //console.log(this._token);
            return this._token;
        }
        return null;
    }

    /**
     * Obteber el menú asignado al usuario
     */
    public get menu(): any {
        this.guardarMenu();
        if (this._menu != null || this._menu != undefined) {
            return this._menu;
        } else if (
            this._menu == null &&
            sessionStorage.getItem('menu') != null
        ) {
            this._menu = JSON.parse(sessionStorage.getItem('menu'));
            return this._menu;
        }
        return null;
    }

    autenticar(username: string, password: string): Observable<any> {
        return this.http.get<any>('assets/user.json').pipe(
            map((response) => {
                console.log('response es ', response);
                this.guardarToken(response.accessToken);
                this.guardarRefreshToken(response.refreshToken);
                this.guardarMenu();
            }),
            catchError((error) => {
                if (error.status == 400) {
                    Swal.fire(
                        'Error de autenticación',
                        'Usuario o clave incorrectas',
                        'error'
                    );
                }
                return throwError(error);
            })
        );
    }

    /**
     * Guardar información del usuario en sessionStorage
     * @param usuario
     */
    guardarUsuario(): void {
        const payLoad = this.obtenerDatosToken(this._token);
        const usuario: Usuario = payLoad.user;
        sessionStorage.setItem('usuario', JSON.stringify(usuario));
    }

    /**
     * Guardar información del token en sessionStorage
     * @param access_token
     */
    guardarToken(access_token: string): void {
        this._token = access_token;
        sessionStorage.setItem('token', this._token);
        this.guardarUsuario();
    }

    /**
     * Guardar información del menu asignado al usuario en LOCALStorage
     * @param menu
     */
    guardarMenu(): void {
        const userRol = JSON.parse(localStorage.getItem('userRol'));
        const menu: any = [
            {
                idMenu: 2,
                routerLink: 'inicio',
                label: 'Inicio',
                icon: '',
                header: false,
                clase: 'nav-item',
                estado: true,
                orden: 2,
                idMenupadre: null,
            },
        ];

        if (userRol === 'AgenteVigilado') {
            menu.push(
                {
                    idMenu: 3,
                    routerLink: null,
                    label: 'Productos',
                    icon: null,
                    header: true,
                    clase: 'nav-item',
                    estado: true,
                    orden: 3,
                    idMenupadre: null,
                },
                {
                    idMenu: 4,
                    routerLink: 'consultar',
                    label: 'Productos',
                    icon: './assets/images/buscar.png',
                    header: false,
                    clase: 'nav-item',
                    estado: true,
                    orden: 4,
                    idMenupadre: 3,
                },
                {
                    idMenu: 6,
                    routerLink: 'carga-consulta-reportes',
                    label: 'Reportes',
                    icon: './assets/images/crear.png',
                    header: false,
                    clase: 'nav-item',
                    estado: true,
                    orden: 6,
                    idMenupadre: 3,
                },
                {
                    idMenu: 7,
                    routerLink: 'carga-consulta-novedades',
                    label: 'Novedades',
                    icon: './assets/images/crear.png',
                    header: false,
                    clase: 'nav-item',
                    estado: true,
                    orden: 7,
                    idMenupadre: 3,
                },
                {
                    idMenu: 8,
                    routerLink: null,
                    label: 'Administrar',
                    icon: null,
                    header: true,
                    clase: 'nav-item',
                    estado: true,
                    orden: 7,
                    idMenupadre: null,
                }
            );
        } else if (userRol === 'Administrador (UPRA)') {
            menu.push(
                {
                    idMenu: 9,
                    routerLink: 'busqueda-user',
                    label: 'Usuarios',
                    icon: './assets/images/buscar.png',
                    header: true,
                    clase: 'nav-item',
                    estado: true,
                    orden: 8,
                    idMenupadre: null,
                },
                {
                    idMenu: 10,
                    routerLink: 'parametros',
                    label: 'Parámetros',
                    icon: './assets/images/buscar.png',
                    header: true,
                    clase: 'nav-item',
                    estado: true,
                    orden: 9,
                    idMenupadre: null,
                },
                {
                    idMenu: 11,
                    routerLink: 'tableros-bi',
                    label: 'Tableros BI',
                    icon: './assets/images/buscar.png',
                    header: true,
                    clase: 'nav-item',
                    estado: true,
                    orden: 10,
                    idMenupadre: null,
                }
            );
        }

        this._menu = menu;
        sessionStorage.setItem('menu', JSON.stringify(this._menu));
    }

    /**
     * Leer información dentro del token
     * @param access_token
     */
    obtenerDatosToken(access_token: string): any {
        if (access_token != null) {
            return JSON.parse(atob(access_token.split('.')[1]));
        }
        return null;
    }

    guardarRefreshToken(rt: string): void {
        sessionStorage.setItem('refreshToken', rt);
    }

    /**
     * Validar si el usuario esta autenticado y tiene la sesión activa
     */
    isAuthenticated(): boolean {
        const payLoad = this.obtenerDatosToken(this.token);
        if (payLoad != null && payLoad.user && payLoad.exp) {
            // user_name && payLoad.user_name.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Cerrar sesión
     */
    logOut(): void {
        this._token = null;
        this._usuario = null;
        sessionStorage.clear();
        /*
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('usuario');
    */
    }

    hasRol(rol: string) {
        if (this.usuario.roles.includes(rol)) {
            return true;
        }
        return false;
    }

    setUsuarioLogueado(logueado: boolean) {
        this.usuarioLogueado.next(logueado);
    }

    getUsuarioLogueado(): Observable<boolean> {
        return this.usuarioLogueado.asObservable();
    }
}
